import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

import { RefundFormValues } from 'components/Dialogs/Finance/RefundDialog/RefundSchema';

import { Refund } from './GetRefund';

export type UpdateRefundResult = Refund | null;
export type UpdateRefundParams = RefundFormValues;

async function updateRefund(params: UpdateRefundParams): Promise<UpdateRefundResult> {
  // ensure refund has an id
  if (!params?.id) {
    throw new Error('Refund id is required');
  }

  // make api call
  const result = await privateApi.put(`${import.meta.env.VITE_API_BASE_URL}/finance/refunds/${params.id}`, params);

  // return the data object
  return result.data as Refund | null;
}

const useUpdateRefund = createMutation<UpdateRefundResult, UpdateRefundParams, AxiosError<ErrorResponse>>({
  mutationFn: async (variables: UpdateRefundParams) => updateRefund(variables),
});

export { updateRefund, useUpdateRefund };
